// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"209e1c9c","3420":"cfff3f33","7350":"8dfd412f"}[chunkId] + ".css";
};